export default __webpack_public_path__ + "static/media/162381462_108636487977540_5385674407919614888_n.7e8a0245.jpg";